<template>
    <div>
        <base-crud crudName="Áreas" newText="Nova Área" :table="teamTable" :columns="columns" :options="options"
            :endPoint='endPoint' :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false">
        </base-crud>
    </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

export default {
    data: function () {
        return {
            teamTable: 'teamTable',
            teams: [],
            pages: [],
            url: '',
            columns: ['id', 'photo', 'name', 'viewAllEvents', 'actions'],
            tableData: ['id', 'photo', 'name', 'viewAllEvents'],
            options: {
                filterable: ["id", "name"],
                filterByColumn: true,
                sortable: ['id', 'name'],
                pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    'id': 'ID',
                    'photo': 'Foto',
                    'name': 'Nome',
                    'viewAllEvents': 'Visualização de todos os eventos',
                    'actions': 'Ações'
                },
                templates: {
                    viewAllEvents: (h, row, index) => {
                        if (row.viewAllEvents) {
                            return 'Sim'
                        }
                        return 'Não';
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [];

                    return this.$http
                        .get(this.url + '?' + query, requestData)
                        .then(function (response) {
                            console.log("Response:", response);
                            return response; 
                        })
                        .catch(
                            function (e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                },
            },
            endPoint: 'teams/'
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: 'id',
                name: 'name',
                viewAllEvents: 'viewAllEvents',
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        }
    },
    components: {
        BaseCrud
    }
}
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Team/Crud.vue